import ClienteCrud from './ClienteCrud.vue'

export default ClienteCrud
